import { IconButton } from "components/icon-button/IconButton";
import React from "react";
import { ArrowLeft, ArrowRight } from "assets/icons";
import { i18nService } from "services";

export interface SlideProps {
  isActive: boolean;
  currentSlide?: number;
  totalSlides?: number;
  isPrevActive?: boolean;
  isNextActive?: boolean;
  handlePrevClick?: () => void;
  handleNextClick?: () => void;
}

interface GallerySlideProps extends SlideProps {
  media: JSX.Element;
  title?: string;
  description?: string;
}

export const GallerySlide: React.FC<GallerySlideProps> = ({
  media,
  title,
  description,
  currentSlide,
  totalSlides,
  isPrevActive,
  isActive,
  isNextActive,
  handlePrevClick,
  handleNextClick,
}) => {
  return (
    <div className="gallery-slide">
      {media}
      <div className="gallery-slide__info">
        {(title || description) && (
          <div className="caption gallery-slide__caption">
            <div className="caption__info">
              {title && <strong className="caption__title">{title}</strong>}
              {description && (
                <div
                  className="caption__description"
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              )}
            </div>
          </div>
        )}
        {totalSlides && totalSlides > 1 && (
          <div className="gallery-slide__nav">
            {handlePrevClick && (
              <IconButton
                label={i18nService.copy["a11y.prev"]}
                size="s"
                Icon={ArrowLeft}
                onClick={handlePrevClick}
                disabled={!isPrevActive}
              />
            )}

            <span>
              <strong className="gallery-slide__active-slide">
                {currentSlide}
              </strong>
              /{totalSlides}
            </span>

            {handleNextClick && (
              <IconButton
                label={i18nService.copy["a11y.next"]}
                size="s"
                Icon={ArrowRight}
                onClick={handleNextClick}
                disabled={!isActive}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
